var BaseView = require('../../../components/accordion-list/categories-director');
var SubCategoriesView = require('./stickers');
var CreateMixin = require('../../../components/mixins/create');

module.exports = Backbone.mixin(BaseView.extend({
  class: 'sub-category stickers',
  CategoriesView: SubCategoriesView,
  views: {},

  initialize: function () {
    this.createButtonMargin = 31;
    this.tool = INKIVE.Tool.getInstance();
    this.modalData = new INKIVE.ModalAdminSticker({ isPlaceholder: true });
    this.mode = 'sticker';
    this.addButtonText = 'tool.admin.new_placeholder';
    this.createCallback = $.noop;

    BaseView.prototype.initialize.call(this);
    this.render();
  },

  _render: function () {
    BaseView.prototype._render.apply(this, arguments);
    this.$el.find('.wrapper').css('top', this.createButtonMargin + 'px');
  },

  addNewEvent: function (event, data) {
    this.modalData = new INKIVE.ModalAdminSticker({ isPlaceholder: true, data: data });
    this.modal = INKIVE.Modal.modalWindow(this.modalData.getFormHtml(), {
      width: 600,
      headerIcon: 'icon-news',
      headerTitle: 'modal.title.new_placeholder',
      buttons: [{
        title: INKIVE.TranslateHelper.translate('modal.buttons.create_placeholder'),
        onClick: _.bind(this.createTemplate, this)
      }]
    });
  },

  toggleAcordionElement: function ($button, value) {
    var $container = $button.closest('dt');
    var $wrapper = $container.closest('.wrapper');
    var top = this.createButtonMargin - $container.position().top;
    BaseView.prototype.toggleAcordionElement.apply(this, arguments);
    $wrapper.css('top', value
      ? top + 'px'
      : this.createButtonMargin + 'px'
    );
  },

  extractData: function (data) { return []; }
}), CreateMixin);
